import React from 'react';
import { Link } from 'react-router-dom';

import logo from '../../static/img/logo_sm.png';
import { LogoArea } from './AppHeader.styles';

const HeaderLogo: React.FC = () => {
  return (
    <LogoArea>
      <Link to="/" aria-label="Raptor Admin home">
        <img alt="Raptor Maps Inc." src={logo} height={32} />
      </Link>
      <div style={{ lineHeight: 1.2, marginLeft: 8 }}>
        <div style={{ fontSize: 13, fontWeight: 700, color: '#333333' }}>
          Raptor
        </div>
        <div style={{ fontSize: 11, fontWeight: 400, color: '#888888' }}>
          Admin
        </div>
      </div>
    </LogoArea>
  );
};

export default HeaderLogo;
